import { TranslocoService } from '@ngneat/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { FileDocument } from '../models/file-document.model';
import { FileDocumentService } from '../services/file-document.service';
import { FileProveDocumentViewModalComponent } from '../file-prove-document-view-modal/file-prove-document-view-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { documentFileSignaturesData } from '../models/documentFileSignatures.model';
import { MessageService } from '../errorHandler/message.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';
import {LocalStorageService} from "../services/local-storage.service";
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';



// Marca para distinguir "no hay evidencia" de un error del backend
const NOM151_EVIDENCE_NOT_FOUND = Symbol('nom151EvidenceNotFound');

@Component({
  standalone: false,
  selector: 'app-file-document-state',
  templateUrl: './file-document-state.component.html',
  styles: []
})
export class FileDocumentStateComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @Input() item: FileDocument;
  @Input() sign: documentFileSignaturesData;
  @Input() showSmallChips: boolean;

  useDocComments = false;

  constructor(
    private readonly fileDocumentService: FileDocumentService,
    private readonly dialog: MatDialog,
    private readonly msjService: MessageService,
    private readonly localStorage: LocalStorageService,
    private readonly transloco: TranslocoService,
    private readonly router: Router
  ) {

  }

  ngOnInit() {
    this.useDocComments = this.localStorage.get('useDocComments');
  }

  verEvidenciasdeFirmas(item: FileDocument) {
    let collaboration = [];
    this.fileDocumentService.getCollaboration(item.id, item.organizationalUnitId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(coll => {
        collaboration = coll;
        const signature = item.documentFileSignaturesData?.[0];
        const sourceDocument = signature?.proveDocumentId
          ? Promise.resolve(item)
          : firstValueFrom(this.fileDocumentService.getDocumentDetail(item.id));

        sourceDocument.then(source => {
          const signatures = source.documentFileSignaturesData ?? [];
          const proveDocumentId = signature?.proveDocumentId ?? signatures[0]?.proveDocumentId;
          if (!proveDocumentId) {
            throw NOM151_EVIDENCE_NOT_FOUND;
          }
          const employeeModule = this.fileDocumentService.isEmployeeModuleUrl(this.router.url);
          return firstValueFrom(this.fileDocumentService.getProveDocument(proveDocumentId, employeeModule))
            .then(({ document, filePdf }) => ({ res: document, filePdf, signatures }));
        }).then(({ res, filePdf, signatures }) => {
          res.employeeCollaborationData = item.employeeCollaborationData;
          res.lawyerCollaborationData = item.lawyerCollaborationData;
          res.documentFileSignaturesData = signatures;
          res.collaboration = collaboration;
          res.documentDate = new Date(signatures[0].signedDate);
          this.dialog.open(FileProveDocumentViewModalComponent, { data: Object.assign(res, { filePdf }) });
        }).catch(error => {
          if (error === NOM151_EVIDENCE_NOT_FOUND) {
            this.msjService.showInfo(this.transloco.translate('fileDocuments.fileDocumentDetail.nom151EvidenceNotFoundMsg'));
            return;
          }
          this.msjService.showError(error);
        });
      });
  }

}
